import type { PreloadedQuery } from 'react-relay';
import type { FragmentRefs, PreloadableConcreteRequest } from 'relay-runtime';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
// inline import QUERY from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/common/ui/virtual-agent/__generated__/VirtualAgentSidebarQuery$parameters';
// eslint-disable-next-line jira/import-whitelist
import checkForAiEnabledFFProvider from '@jira/platform__graphql-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider.tsx';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';

const QUERY: PreloadableConcreteRequest<VirtualAgentSidebarQuery> = {
	kind: 'PreloadableConcreteRequest',
	params: {
		id: 'f8d8b9eec1994f8c7411bb76dc10be0eab8514a591963f4d58e52f323d48b997',
		metadata: {},
		name: 'VirtualAgentSidebarQuery',
		operationKind: 'query',
		text: null,
		providedVariables: {
			__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaisrequireaienabledrelayprovider:
				checkForAiEnabledFFProvider,
		},
	},
};

// inline import type { VirtualAgentSidebarQuery } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/common/ui/virtual-agent/__generated__/VirtualAgentSidebarQuery.graphql';
export type VirtualAgentSidebarQuery$variables = {
	checkForAiEnabledFF: boolean;
	cloudId: string;
	key: string;
};
export type VirtualAgentSidebarQuery$data = {
	readonly jira: {
		readonly jiraProjectByKey: {
			readonly virtualAgentConfiguration:
				| {
						readonly __typename: string;
						readonly ' $fragmentSpreads': FragmentRefs<'VirtualAgentNestedNav437BadPattern'>;
				  }
				| null
				| undefined;
		};
	};
	readonly virtualAgent:
		| {
				readonly virtualAgentEntitlements:
					| {
							readonly isAiEnabledInAdminHub?: boolean | null | undefined;
							readonly isVirtualAgentAvailable: boolean | null | undefined;
							readonly ' $fragmentSpreads': FragmentRefs<'VirtualAgentNestedNav'>;
					  }
					| null
					| undefined;
		  }
		| null
		| undefined;
};
export type VirtualAgentSidebarQuery = {
	response: VirtualAgentSidebarQuery$data;
	variables: VirtualAgentSidebarQuery$variables;
};

export const virtualAgentOnboardingResource: RouteResource<
	PreloadedQuery<VirtualAgentSidebarQuery, Record<string, unknown>>
> = createRelayResource<VirtualAgentSidebarQuery>({
	type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
	isBrowserOnly: true,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			key: match.params.projectKey || '',
			checkForAiEnabledFF: fg('require_ai_enabled_for_jsm_virtual_agent'),
		},
	}),
});
